import {Alert, Backdrop, Button, CircularProgress, Container, TextField, Typography} from "@mui/material";
import {TimeManager} from "../timemanager";
import {useState} from "react";
import {useSearchParams} from "react-router-dom";

export default function CreateAccount() {
    const [searchParams] = useSearchParams();

    const email = searchParams.get('email');
    const token = searchParams.get('token');

    const [alert, setAlert] = useState("");

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [loading, setLoading] = useState(false);

    const requestCreate = () => {
        if (username.length > 0 && password.length > 0) {
            (async () => {
                setLoading(true);

                await TimeManager.account.create(token, email, username, password)
                    .then(setAlert)
                    .catch(setAlert);

                setLoading(false);
            })();
        }

        return false;
    };

    return (
        <Container
            sx={{
                width: '350px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100vh',
            }}
        >
            {alert && (
                <Alert
                    severity={alert.error ? 'error' : 'success'}
                    onClose={() => setAlert(null)}
                    sx={{ mb: '20px' }}
                >
                    {alert.message || alert.success} {alert.success && <>Login <a href="/login">here</a>.</>}
                </Alert>
            )}

            <Typography
                textAlign="center"
                mb="30px"
            >
                {email}
            </Typography>

            <TextField
                label="Username"
                sx={{
                    mb: '20px',
                }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
            />

            <TextField
                label="Password"
                type="password"
                sx={{
                    mb: '20px',
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />

            <Button
                variant="contained"
                onClick={requestCreate}
            >
                Create Account
            </Button>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    );
}